/**
 * Registers a service worker and returns a promise that resolves to the registration.
 * @param {string} swPath public path to the service worker
 * @returns {ServiceWorkerRegistration} Service worker registration
 */
const getSWRegistration = async swPath => navigator.serviceWorker.register(swPath);

export const getFleetbackSWRegistration = async () => getSWRegistration('/sw.js');
